import type { BreedId } from '../data/types';
import { drawHen, drawRoosterSprite } from '../render/sprites';
import { h } from './dom';

/** Small pixel-art portraits for shop cards (drawn from the sprite sheets). */
export function henPortrait(breed: BreedId, size = 44): HTMLCanvasElement {
  const c = h('canvas', { class: 'portrait', width: size, height: size });
  const ctx = c.getContext('2d');
  if (ctx) drawHen(ctx, breed, 0, 0, 0, 0, size);
  return c;
}

export function roosterPortrait(breed: BreedId, size = 44): HTMLCanvasElement {
  const c = h('canvas', { class: 'portrait', width: size, height: size });
  const ctx = c.getContext('2d');
  if (ctx) drawRoosterSprite(ctx, breed, 0, 0, 0, 0, size);
  return c;
}
